import styled from "styled-components"

const Image = styled.img`
  width: 50px;
  height: 50px;
  margin-right: 15px;

  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    width: 80px;
    height: 80px;
    margin-right: 20px;
  `}
`

export default Image
